/* eslint-disable */
// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import api from "@/utils/api";
import http from "@/utils/http";
import { Button, message, Modal } from "antd";
const VendorHeatmapChart = ({ data, timeList, timestamps }) => {
  const chartRefs = useRef({});
  const [yAxisDataState, setYAxisDataState] = useState([]);
  const yAxisDataRef = useRef([]);

  const handleSendButtonClick = async (vendorData) => {
    // console.log("当前点击的vendor数据:", vendor);
    Modal.confirm({
      title: "Confirm Payment",
      content: `Are you sure you want to submit payment for vendor ${vendorData.vendorName}?`,
      okText: "Confirm",
      cancelText: "Cancel",
      onOk: async () => {
        try {
          const queryParams = new URLSearchParams({
            sTime: timestamps.startTime,
            eTime: timestamps.endTime,
            vendorId: vendorData.vendorId,
          });

          const response = await http.get(
            `${api.getManualToPay}?${queryParams.toString()}`
          );

          if (response && response.code === "1") {
            message.success("Payment submitted successfully!");
            // Force page refresh after 1 second
            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          } else {
            message.error("Submission failed. Please try again.");
          }
        } catch (err) {
          console.error("Request error:", err);
          message.error("An error occurred. Please try again.");
        }
      },
    });
  };
  const handleVendorClick = (vendorData) => { };

  const formatDollar = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };
  useEffect(() => {
    if (!timeList || !timeList.startTime || !timeList.endTime) {
      console.warn("Please select a date to proceed with the query.");
      return;
    }

    if (!data || !data.length) return;
    // console.log("组件接收的data:", data);
    data.forEach((vendor) => {
      const chartDom = chartRefs.current[`chart-${vendor.vendorId}`];
      if (!chartDom) return;

      const seriesData = [];
      const yAxisData = [];
      // 动态计算高度
      const minHeight = yAxisData.length === 1 ? 180 : 280;
      const maxHeight = 1200;
      const minItemHeight = 80;

      const generateTimeLabels = (start, end) => {
        const labels = [];
        let current = new Date(start);
        const endDate = new Date(end);

        // 使用本地时间处理
        current.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);

        while (current <= endDate) {
          labels.push(
            `${current.getFullYear()}-${String(current.getMonth() + 1).padStart(
              2,
              "0"
            )}-${String(current.getDate()).padStart(2, "0")}`
          );
          current.setDate(current.getDate() + 1);
        }
        return labels;
      };
      const timeLabels = generateTimeLabels(
        timeList.startTime,
        timeList.endTime
      );

      vendor.vendorPropWorkRecordList.forEach((propRecord, propIndex) => {
        //  console.log('data', vendor.vendorPropWorkRecordList);
        yAxisData.push({
          prop: propRecord.prop,
          totalAmount: propRecord.totalAmount,
          vendorId: vendor.vendorId,
          paidAmount: propRecord.paidAmount,
          unpaidAmount: propRecord.unpaidAmount,
          type: propRecord.type,
        });
        propRecord.dailyWorkRecords.forEach((dayRecord) => {
          // 直接使用时间戳创建日期对象
          const dateObj = new Date(dayRecord.workDate);
          const dateStr = `${dateObj.getFullYear()}-${String(
            dateObj.getMonth() + 1
          ).padStart(2, "0")}-${String(dateObj.getDate()).padStart(2, "0")}`;
          // console.log(dayRecord);
          if (timeLabels.includes(dateStr)) {
            const hasPaid = dayRecord.records.some(
              (record) => record.pay !== 0
            );
            const payAmount = dayRecord.records[0]?.payAmount || 0;
            const assignedAmount = dayRecord.assignedAmount;

            seriesData.push({
              name: dateStr,
              value: [dateStr, propIndex, dayRecord.dailyCount],
              itemStyle: { color: hasPaid ? "#91c7ae" : "#ff6b6b" },
              extraData: {
                date: dateStr,
                prop: propRecord.prop,
                count: dayRecord.dailyCount,
                records: dayRecord.records,
                payAmount: payAmount,
                assignedAmount: assignedAmount,
                rawDate: dayRecord.workDate,
              },
            });
          }
        });
      });
      // **计算动态图表高度**

      const computedHeight =
        yAxisData.length === 1
          ? 180
          : Math.min(
            maxHeight,
            Math.max(280, yAxisData.length * minItemHeight)
          );
      const chartHeight = Math.min(
        maxHeight,
        Math.max(minHeight, computedHeight)
      );

      // **更新 DIV 容器高度**
      const container = chartDom.parentElement;
      container.style.height = `${computedHeight}px`;
      chartDom.style.height = `${computedHeight}px`;
      // **初始化图表**
      const chart =
        echarts.getInstanceByDom(chartDom) || echarts.init(chartDom);
      yAxisDataRef.current = yAxisData;
      const option = {
        title: {
          text: `${vendor.vendorName} |  Daily Amount : ${formatDollar(
            vendor.dailyAmount
          )}`,
          left: 10,
          top: 0,
          bottom: 10,
          textStyle: {
            fontSize: 16,
            fontWeight: "bold",
          },
          subtextStyle: {
            fontSize: 14,
            color: "#666",
          },
        },

        tooltip: {
          formatter: function (params) {
            const data = params.data.extraData;
            const payStatus = data.records.some((record) => record.pay === 1);
            const amountDisplay = payStatus
              ? `<div>Pay Amount: ${formatDollar(data.payAmount)}</div>`
              : `<div>Assigned Amount: ${formatDollar(
                data.assignedAmount
              )}</div>`;
            const createByName = data.records[0]?.createByName || " ";
            const clockTimeDate = data.records[0]?.strClockTime || " ";
            return `
              <div style="padding: 8px; background: #fff; border-radius: 4px; box-shadow: 0 0 8px rgba(0,0,0,0.1)">
                <div style="font-weight: bold; margin-bottom: 6px; color: #333;">${clockTimeDate}</div>
                <div style="margin-bottom: 4px;">Vendor Name: ${vendor.vendorName}</div>
                <div style="margin-bottom: 4px;">Create Name: ${createByName}</div>
                ${amountDisplay}
              </div>
            `;
          },
          extraCssText: "z-index: 9999;",
          appendToBody: true,
        },
        grid: {
          left: "3%",
          right: "3%",
          top: 25,
          bottom: "8%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: timeLabels,
          position: "top",
          axisLabel: {
            formatter: function (value) {
              return value.split("-").slice(1).join("/");
            },
            interval: 0,
            rotate: 0, // 适当旋转防止重叠
            color: "#666",
            verticalAlign: "middle",
            align: "center",
          },
          axisLine: {
            lineStyle: {
              color: "#999",
              width: 1,
            },
          },
          axisTick: {
            // alignWithLabel: true,
            lineStyle: {
              color: "#999",
              width: 1,
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#ddd",
              width: 1,
              type: "solid",
            },
          },
        },
        yAxis: {
          type: "category",
          data: yAxisData.map((item) => item.prop),
          axisLabel: {
            interval: 0,
            width: 250,
            formatter: function (value, index) {
              const item = yAxisData[index];
              const lines = [
                `{line1|Prop: ${value}}`,
                `{line2|Total: ${formatDollar(item.totalAmount)}}`,
                `{line3|Paid: ${formatDollar(item.paidAmount)}}`,
              ];
              if (item.type !== "1") {
                lines.push(
                  `{line4|Unpaid: ${formatDollar(item.unpaidAmount)}}`
                );
              }

              return lines.join("\n");
            },
            rich: {
              bold: {
                fontSize: 16,
                color: "#333",
              },
              line1: {
                color: "#666",
                fontWeight: "bold",
              },
              line2: {
                color: "#666",
              },
              line3: {
                color: "#666",
              },
              line4: {
                color: "#666",
              },
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ddd",
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "#ddd",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#666"],
              type: "dashed",
            },
          },
          splitNumber: Math.min(10, yAxisData.length),
        },

        series: [
          {
            name: "Work Record",
            type: "scatter",
            /**
             * 计算符号大小
             * @param {Array} val 数据值数组
             * @returns {number} 计算后的符号大小
             */
            // symbolSize: function (val) {
            //   return Math.max(val[2] * 8, 50);
            // },
            symbolSize: function () {
              return 30;
            },
            data: seriesData,
            label: {
              show: false,
              /**
               * 标签格式化函数
               * @param {Object} params 图表参数
               * @returns {string} 格式化后的文本
               */
              formatter: function (params) {
                return params.data.extraData.count;
              },
              color: "#fff",
              fontSize: 12,
              position: "inside",
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowColor: "rgba(255, 251, 251, 0.76)",
              },
              symbolSize: 40,
            },
            /**
             * 动画延迟函数
             * @param {number} idx 数据索引
             * @returns {number} 延迟时间(ms)
             */
            animationDelay: function (idx) {
              return idx * 100;
            },
          },
        ],
        // backgroundColor: "#f9f9f9",
        backgroundColor: "#f9f9f9",
      };

      setYAxisDataState(yAxisData);
      chart.setOption(option, { notMerge: true });

      // 窗口resize处理
      const handleResize = () => chart.resize();
      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
        chart.off("click");
        chart.dispose();
      };
    });
  }, [data, timeList]);
  const chartHeight = Math.max(280, (yAxisDataState.length || 0) * 40);
  if (!timeList || !timeList.startTime || !timeList.endTime) {
    return (
      <div style={{ padding: "20px", color: "#999" }}>
        Please select a date to proceed with the query.
      </div>
    );
  }

  return (
    <div
      style={{
        height: "85vh",
        overflowY: "auto",
        width: "100%",
        position: "relative",
        padding: "10px 0",
        boxSizing: "border-box",
        marginTop: "20px",
      }}
    >
      {data.map((vendor) => (
        <div
          key={vendor.vendorId}
          style={{
            background: "#f9f9f9",
            borderRadius: "10px",
            padding: "0",
            marginTop: "20px",
            width: "98%",
            position: "relative",
          }}
        >
          <div>
            <div
              ref={(el) => (chartRefs.current[`chart-${vendor.vendorId}`] = el)}
              style={{
                width: "100%",
                height: "90%",
              }}
            />
          </div>
          <div
            style={{
              background: "#f0f0f0",
              paddingRight: "3%",
              height: "50px",
              marginBottom: "0px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <div>
              <div key={`amount-${vendor.vendorId}`}>
                <span style={{ marginRight: "10px" }}>
                  {" "}
                  Total Amount : {formatDollar(vendor.totalAmount)}
                </span>
                <span style={{ marginRight: "10px" }}>
                  {" "}
                  Paid Amount :{formatDollar(vendor.paidAmount)}
                </span>
                {vendor.type !== "1" && (
                  <span>
                    {" "}
                    Unpaid Amount : {formatDollar(vendor.unpaidAmount)}
                  </span>
                )}
              </div>
              {(vendor.type === "2" || vendor.type === "4") && (
                <div style={{ color: "#F44336" }}>{vendor.message}</div>
              )}
            </div>

            <div style={{ marginLeft: "10px" }}>
              {vendor.type === "0" && (
                <Button
                  type="primary"
                  size="mini"
                  onClick={(e) => {
                    e.stopPropagation(); // 阻止事件冒泡
                    handleSendButtonClick(vendor);
                  }}
                >
                  Send
                </Button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VendorHeatmapChart;
